export default __webpack_public_path__ + "static/media/Settings_LineTransparency.0db82d3e.svg";